var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{ success: _vm.success },on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"top"},[_vm._t("text")],2),_vm._v(" "),_c('span',{staticClass:"bottom"},[_vm._t("successText")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3933d7e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActionButton.vue
// module id = 534
// module chunks = 1